import { useTranslation } from 'react-i18next';
import { spreadsheetProducts } from '@/mocks/spreadsheetProducts';

export default function SpreadsheetSection() {
  const { t } = useTranslation();

  const renderStars = (count: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`text-xs ${i < count ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
      ></i>
    ));
  };

  return (
    <section id="spreadsheet" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('spreadsheet.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('spreadsheet.subtitle')}
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200/70 bg-secondary-50">
                  <th className="text-left px-5 py-3.5 font-semibold text-foreground-700 text-xs uppercase tracking-wide">
                    {t('spreadsheet.tableHeaders.0')}
                  </th>
                  <th className="text-left px-5 py-3.5 font-semibold text-foreground-700 text-xs uppercase tracking-wide">
                    {t('spreadsheet.tableHeaders.1')}
                  </th>
                  <th className="text-left px-5 py-3.5 font-semibold text-foreground-700 text-xs uppercase tracking-wide">
                    {t('spreadsheet.tableHeaders.2')}
                  </th>
                  <th className="text-left px-5 py-3.5 font-semibold text-foreground-700 text-xs uppercase tracking-wide">
                    {t('spreadsheet.tableHeaders.3')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {spreadsheetProducts.map((item, idx) => (
                  <tr
                    key={idx}
                    className={`border-b border-background-200/50 hover:bg-background-100 transition-colors ${
                      idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                    }`}
                  >
                    <td className="px-5 py-3.5 text-foreground-800 font-medium">{item.product}</td>
                    <td className="px-5 py-3.5">
                      <span className="px-2.5 py-1 text-xs rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                        {item.category}
                      </span>
                    </td>
                    <td className="px-5 py-3.5 text-foreground-800 font-semibold whitespace-nowrap">{item.price}</td>
                    <td className="px-5 py-3.5">
                      <div className="flex items-center gap-0.5">{renderStars(item.rating)}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer no-underline"
          >
            {t('spreadsheet.viewFullList')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}